import { Attribute } from "services/KnowfullyAdminClient";

export function MetaValueColumnView(metaValueName: string) {
  function ColumnView({ value }: { value: Attribute }) {
    const metaValue = value.attributeMetaValues?.find(
      (m) => m.name === metaValueName,
    )?.value;
    return <>{metaValue ?? ""}</>;
  }
  return ColumnView;
}
